export default __webpack_public_path__ + "static/media/feature-launch.5d6dafdb.svg";